// import React, { createContext, useContext, useState, useEffect } from "react";
// import { useCookies } from "react-cookie";

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// function AuthProvider({ children }) {
//   const parseUserCookie = (encodedUser) => {
//     try {
//       return encodedUser ? JSON.parse(atob(encodedUser)) : null;
//     } catch (error) {
//       console.error("Error decoding user cookie:", error);
//       return null;
//     }
//   };

//   const [cookies] = useCookies(["accessToken", "user"]);
//   const [accessToken, setAccessToken] = useState(cookies?.accessToken || "");
//   const [user, setUser] = useState(parseUserCookie(cookies?.user) || "");
//   const isAuthenticated = !!accessToken; // Check if accessToken exists

//   const setContext = (data) => {
//     setAccessToken(data?.accessToken);
//     setUser(data?.user);
//   };

//     const clearContext = () => {
//     setAccessToken(null);
//     setUser(null);
 
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         setContext,
//         clearContext,
//         accessToken,
//         user,
//         isAuthenticated
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export default AuthProvider;

// import React, { createContext, useContext, useState } from "react";
// import { useCookies } from "react-cookie";

// const AuthContext = createContext();

// export const useAuth = () => useContext(AuthContext);

// function AuthProvider({ children }) {
//   const parseUserCookie = (encodedUser) => {
//     try {
//       return encodedUser ? JSON.parse(atob(encodedUser)) : null;
//     } catch (error) {
//       console.error("Error decoding user cookie:", error);
//       return null;
//     }
//   };

//   const [cookies] = useCookies(["accessToken", "user"]);
//   const [accessToken, setAccessToken] = useState(cookies?.accessToken || null);
//   const [user, setUser] = useState(parseUserCookie(cookies?.user) || null);

//   const isAuthenticated = Boolean(accessToken);

//   const setContext = (data) => {
//     setAccessToken(data?.accessToken || null);
//     setUser(data?.user || null);
//   };

//   const clearContext = () => {
//     setAccessToken(null);
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         setContext,
//         clearContext,
//         accessToken,
//         user,
//         isAuthenticated,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export default AuthProvider;

import React, { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import axios from "axios";
import useStore from "../store/store";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

function AuthProvider({ children }) {
  const [cookies] = useCookies(["accessToken"]);
  const [accessToken, setAccessToken] = useState(cookies?.accessToken || null);
  const [user, setUser] = useState(null);
  const [isHydrated, setIsHydrated] = useState(false);

  const setStoreUser = useStore((state) => state.setUser);
  const clearStoreUser = useStore((state) => state.clearUser);

  const isAuthenticated = Boolean(accessToken && user);

  const setContext = (data) => {
    const nextAccessToken = data?.accessToken || null;
    const nextUser = data?.user || null;

    setAccessToken(nextAccessToken);
    setUser(nextUser);

    if (nextUser) {
      setStoreUser(nextUser);
    } else {
      clearStoreUser();
    }
  };

  const clearContext = () => {
    setAccessToken(null);
    setUser(null);
    clearStoreUser();
  };

  useEffect(() => {
    const initAuth = async () => {
      try {
        const refreshRes = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
          {},
          {
            withCredentials: true,
          }
        );

        const newAccessToken = refreshRes.data.accessToken;

        const meRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          {
            headers: {
              Authorization: `Bearer ${newAccessToken}`,
            },
            withCredentials: true,
          }
        );

        const userData = meRes.data.user;

        setAccessToken(newAccessToken);
        setUser(userData);
        setStoreUser(userData);
      } catch (err) {
        Cookies.remove("accessToken", { path: "/" });
        clearContext();
      } finally {
        setIsHydrated(true);
      }
    };

    initAuth();
  }, [setStoreUser]);

  return (
    <AuthContext.Provider
      value={{
        setContext,
        clearContext,
        accessToken,
        user,
        isAuthenticated,
        isHydrated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
